(() => {
  if (window.productMeasurementsInitialized) return;
  window.productMeasurementsInitialized = true;

  const panelSelector = '.product-page__collection-layout--panel';
  const inputSelector = '[data-measurement-input]';
  const unitOptionSelector = '[data-measurement-unit-option]';

  const getPanel = (element) => {
    if (!(element instanceof Element)) return null;

    const panel = element.closest(panelSelector);
    if (panel) return panel;

    return element.closest('product-info')?.querySelector(panelSelector) || null;
  };

  const getError = (input) => input.closest('.product-page__measurement-field')?.querySelector('[data-measurement-error]');

  const validateInput = (input) => {
    const value = input.value.trim();
    let message = '';

    if (!value) {
      message = 'Enter a measurement.';
    } else if (!/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(value)) {
      message = 'Enter a valid number.';
    } else if (!Number.isFinite(Number(value)) || Number(value) <= 0) {
      message = 'Enter a measurement greater than 0.';
    }

    const error = getError(input);
    input.setCustomValidity(message);
    input.setAttribute('aria-invalid', String(Boolean(message)));

    if (error) {
      error.textContent = message;
      error.hidden = !message;
    }

    return !message;
  };

  const validatePanel = (panel, focusInvalid = true) => {
    const inputs = Array.from(panel.querySelectorAll(inputSelector));
    let firstInvalid = null;

    inputs.forEach((input) => {
      if (!validateInput(input) && !firstInvalid) firstInvalid = input;
    });

    if (firstInvalid && focusInvalid) {
      firstInvalid.focus();
    }

    return !firstInvalid;
  };

  const updateUnitSuffixes = (panel) => {
    const unit = panel.querySelector('[data-measurement-unit]')?.value;
    const suffix = unit === 'Centimeters' ? 'cm' : 'in';

    panel.querySelectorAll('[data-measurement-unit-suffix]').forEach((element) => {
      element.textContent = suffix;
    });

    panel.querySelectorAll(unitOptionSelector).forEach((option) => {
      const selected = option.dataset.measurementUnitOption === unit;
      option.classList.toggle('is-active', selected);
      option.setAttribute('aria-pressed', String(selected));
    });
  };

  const initializePanels = () => {
    document.querySelectorAll(panelSelector).forEach(updateUnitSuffixes);
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const panel = getPanel(form);
      if (!panel || !panel.querySelector(inputSelector) || validatePanel(panel)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const unitOption = event.target.closest(unitOptionSelector);
    if (!unitOption) return;

    const panel = getPanel(unitOption);
    const select = panel?.querySelector('[data-measurement-unit]');
    const value = unitOption.dataset.measurementUnitOption;
    if (!panel || !select || !value || !Array.from(select.options).some((option) => option.value === value)) return;

    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    unitOption.focus();
  });

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const paymentButton = event.target.closest(
        panelSelector + ' .shopify-payment-button__button, ' + panelSelector + ' .shopify-payment-button [role="button"]'
      );
      if (!paymentButton) return;

      const panel = getPanel(paymentButton);
      if (!panel || validatePanel(panel)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener('input', (event) => {
    if (!(event.target instanceof HTMLInputElement) || !event.target.matches(inputSelector)) return;
    validateInput(event.target);
  });

  document.addEventListener('focusout', (event) => {
    if (!(event.target instanceof HTMLInputElement) || !event.target.matches(inputSelector)) return;
    validateInput(event.target);
  });

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLSelectElement)) return;

    const panel = getPanel(event.target);
    if (!panel) return;

    if (event.target.matches('[data-measurement-unit]')) {
      updateUnitSuffixes(panel);
    }
  });

  document.addEventListener('shopify:section:load', initializePanels);
  initializePanels();
})();
